import { useOrganizations, useRole } from "@/contexts/UserProvider";
import { useTranslations } from "@/contexts/Translation";
import { ExpiredSubscriptionMessage } from "./ExpiredSubscriptionMessage";

export const CheckSubscription = () => {
  const { subscription, currentOrganization } = useOrganizations();
  const role = useRole();
  const t = useTranslations("dashboard");

  if (!currentOrganization) return null;
  if (subscription.status === "active") return null;

  if (role !== "owner") {
    return <ExpiredSubscriptionMessage title={t("expiredSubTitle")} body={t("expiredSubBodyNotOwner")} />;
  }

  if (subscription.status === "expired") {
    if (subscription.type === "trial") {
      return <ExpiredSubscriptionMessage button={t("activeSubscription")} title={t("trialExpiredSubTitle")} body={t("trialExpiredSubBody")} />;
    }
    return <ExpiredSubscriptionMessage button={t("activeSubscription")} title={t("expiredSubTitle")} body={t("expiredSubBody")} />;
  }

  if (subscription.status === "cancelled") {
    return <ExpiredSubscriptionMessage button={t("activeSubscription")} title={t("expiredSubTitle")} body={t("expiredSubBody")} />;
  }

  return <ExpiredSubscriptionMessage button={t("activeSubscription")} title={t("noSubTitle")} body={t("noSubBody")} />;
};
